<template>
  <div v-if="payInfo">
    <div v-if="isSeparate" class="layer paymentLayer">
      <div class="inner">
        <p class="layerTitle">{{ locale.start_payment }}</p>
        <div class="btns">
          <button type="button" class="btn btnFull" @click.stop="paySubmit">{{ locale.do_payment }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KiccPayment',
  props: [
    'locale'
  ],
  computed: {
    getPayInfo: {
      get () {
        return this.$store.getters['payment/getPaymentInfo']
      },
      set (data) {
        this.payInfo = this._.cloneDeep(data)
      }
    }
  },
  mounted () {
    this.isSeparate = this.$route.name === 'separatePayment'
    if (this.getPayInfo) {
      this.payInfo = this._.cloneDeep(this.getPayInfo)
      // 알림톡 등으로부터 접근한 기본루트
      if (!this.isSeparate) {
        setTimeout(() => {
          window.location.href = this.payInfo.url
        }, 100)
      } else {
        // QR코드로부터 접근한 독립 결제루트
      }
    }
  },
  data () {
    return {
      payInfo: null,
      isSeparate: false
    }
  },
  methods: {
    paySubmit () {
      window.location.href = this.payInfo.url
    },
    closePayment (e) {
      if (window.confirm(this.locale.confirm_cancel_payment)) {
        e.preventDefault()
        window.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.paymentLayer {
  .inner {
    padding: 45px 30px;
    border-radius: 8px;
  }
  .layerTitle {
    text-align: center;
  }
  .btns {
    margin-top: 30px;
    .btn {
      padding-top: 1em;
      padding-bottom: 1em;
      border-radius: 8px;
    }
  }
}
</style>
